var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrice = function SvgPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Price_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.405 4.104a2.25 2.25 0 0 1 2.037 2.037l.353 3.89a2.25 2.25 0 0 1-.65 1.794l-7.491 7.492a2.25 2.25 0 0 1-3.182 0l-4.243-4.243a2.25 2.25 0 0 1 0-3.182L11.721 4.4a2.25 2.25 0 0 1 1.795-.65l3.889.354Zm3.53 1.901a3.75 3.75 0 0 0-3.394-3.395l-3.89-.353a3.75 3.75 0 0 0-2.99 1.083l-7.492 7.492a3.75 3.75 0 0 0 0 5.303l4.242 4.242a3.75 3.75 0 0 0 5.303 0l7.492-7.491a3.75 3.75 0 0 0 1.083-2.991l-.354-3.89ZM14.13 7.65a1.25 1.25 0 1 1 1.767 1.767A1.25 1.25 0 0 1 14.13 7.65Zm2.828-1.061a2.75 2.75 0 1 0-3.889 3.889 2.75 2.75 0 0 0 3.89-3.89Zm-6.796 4.07a.75.75 0 1 0-1.06 1.06l3.181 3.182a.75.75 0 0 0 1.06-1.06l-3.181-3.182ZM6.979 12.78a.75.75 0 0 1 1.06 0l1.768 1.768a.75.75 0 1 1-1.06 1.06l-1.768-1.767a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Price_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPrice;